/** The first image of image content (or its card), for card previews and their sizes. */

import { knownImageSize } from "@/lib/image-natural-size";

export interface CardImage {
  /** Empty when the card dropped inline bytes (`frame_card.py`). */
  url: string;
  alt: string;
  /**
   * The pixel size the content records, else the size the image showed
   * when it loaded (`image-natural-size.ts`); null when neither is known.
   */
  width: number | null;
  height: number | null;
  /** width / height, null when the size is unknown. */
  aspect: number | null;
}

function positive(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) && value > 0
    ? value
    : null;
}

export function firstCardImage(images: unknown): CardImage | null {
  if (!Array.isArray(images)) return null;
  const image = images[0] as Record<string, unknown> | undefined;
  if (!image || typeof image !== "object") return null;
  const url = typeof image.url === "string" ? image.url : "";
  const storedWidth = positive(image.width);
  const storedHeight = positive(image.height);
  const size =
    storedWidth && storedHeight
      ? { width: storedWidth, height: storedHeight }
      : knownImageSize(url);
  return {
    url,
    alt: typeof image.alt === "string" ? image.alt : "",
    width: size?.width ?? null,
    height: size?.height ?? null,
    aspect: size ? size.width / size.height : null,
  };
}
